module.exports = __webpack_public_path__ + "img/unchecked-star.c229e5ac.svg";